import * as React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {Box,Card,CardMedia,Collapse,Container,Fade,FormControlLabel,Grid,Typography,} from "@mui/material";
import Switch from '@mui/material/Switch';
import Slide from '@mui/material/Slide';
import { styled } from "@mui/material/styles";
// import { keyframes } from "@emotion/react";
import { keyframes } from "@mui/system";
import { black, TypographyBrand } from '../../../getLPTheme';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {useRef, useEffect} from 'react';


gsap.registerPlugin(ScrollTrigger);

export default function VideoTierra () {

  const textRef1 = useRef(null);
  const textRef2 = useRef(null);
  const textRef3 = useRef(null);
  const beneficioref1 = useRef(null);
  const beneficioref2 = useRef(null);
  const beneficioref3 = useRef(null);
  const beneficioref4 = useRef(null);


  useEffect(()=> {

    const box1 = textRef1.current;
    const box2 = textRef2.current;
    const box3 = textRef3.current;

    const boxBen1 = beneficioref1.current;
    const boxBen2 = beneficioref2.current;
    const boxBen3 = beneficioref3.current;
    const boxBen4 = beneficioref4.current;


    // gsap.fromTo(box1, {x: 1000}, {x:1, duration: 0.5, 
    //   scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})

    // gsap.fromTo(box2, {x: -1000}, {x:1, duration: 0.5, delay: 0.5, 
    //   scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})  
    
    gsap.to(box3, {innerText: 1000, duration: 3, snap: {innerText: 10}, 
      scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}}) 


    gsap.fromTo(boxBen1, {x: 1000}, {x:1, duration: 0.5, 
      scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})

    gsap.fromTo(boxBen2, {x: 1000}, {x:1, duration: 0.5, delay: 0.5, 
      scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})  
    
    gsap.fromTo(boxBen3, {x: 1000}, {x:1, duration: 0.5, delay: 1, 
      scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})  
    
    gsap.fromTo(boxBen4, {x: 1000}, {x:1, duration: 0.5, delay: 1.5, 
      scrollTrigger: {trigger: box3, start: "top 60%", end:"top 40%", toggleActions: "restart none restart none"}})  

  })
  

  return (
    <Box id="videoTierra" sx={{gap:8, mt:10}}>
    <Container>  
      <div>
        <Box ref={textRef1} sx={{width: "100%"}}>
          <TypographyBrand sx={{p:0, fontSize: {xl: "3vw", lg: "3vw", md: "3vw", sm:"3vw", xs:"5vw"}}}>
            UNA PLATAFORMA
          </TypographyBrand>
        </Box>
        <Box ref={textRef2} sx={{p:0, width: "100%",height: "75px",}}>
          <TypographyBrand sx={{fontSize: {xl: "3vw", lg: "3vw", md: "3vw", sm:"3vw", xs:"5vw"}}}>
            MILES DE BENEFICIOS
          </TypographyBrand>
        </Box>
        <Card sx={{ backgroundColor: black[1000], width: '100%', border: '0px', outline: "none", boxShadow: "none"}}>
          <Box sx={{ position: 'relative' }}>
            <CardMedia
              component='video'
              image={"https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/banner_pelota_girando.mp4"}
              autoPlay
              loop
              muted
              sx={{height: {xl: 700, lg: 650, md: 650}, border: 'none', borderInline: "none",boxShadow: "none"}}
            >
            </CardMedia>
            <Box sx={{
              position: 'absolute',
              top: "20%",
              left: 0,
              width: '100%',
              color: 'white',
              padding: '5px',
              direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"
              }}
            >
              <Box sx={{pt:{xl: 3, lg: 3, md:2, sm:2, xs: 0}}}>
                <Grid container direction="row" justifyContent="center" alignItems="center">
                  <Grid item xs={4}>
                    <Box sx={{direction:"row", justifyContent:"start", alignItems:"center", display: 'flex',}} >
                      <Box>
                        <Typography textAlign="center" color='white' sx={{fontSize: {xl: "3vw", lg: "3vw", md: "3vw", sm:"3vw", xs:"5vw"}}}>+</Typography>
                      </Box>
                      <Box>
                        <Typography ref={textRef3} textAlign="center" color='white' sx={{fontSize: {xl: "3vw", lg: "3vw", md: "3vw", sm:"3vw", xs:"6vw"}}}></Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    <Box sx={{direction:"row", justifyContent:"center", alignItems:"center", width: "100%" }}>
                      <Box> 
                        <div className='containerText'>
                            <Typography variant="h2" ref={beneficioref1} sx={{textAlign: "start",fontSize: {xl: "3.5vw", lg: "4vw", md: "4vw", sm:"4vw", xs:"6vw"}}}>CLUBES</Typography>
                        </div>
                      </Box>
                      <Box> 
                        <div className='containerText'>
                          <Typography variant="h2" ref={beneficioref2} sx={{textAlign: "start",fontSize: {xl: "3.5vw", lg: "4vw", md: "4vw", sm:"4vw", xs:"6vw"}}}>HOTELES</Typography>
                        </div>
                      </Box>
                      <Box> 
                        <div className='containerText'>
                          <Typography variant="h2" ref={beneficioref3} sx={{textAlign: "start",fontSize: {xl: "3.5vw", lg: "4vw", md: "4vw", sm:"4vw", xs:"6vw"}}}>RESTAURANTES</Typography>
                        </div>
                      </Box>
                      <Box> 
                        <div className='containerText'>
                          <Typography variant="h2" ref={beneficioref4} sx={{textAlign: "start", fontSize: {xl: "3.5vw", lg: "4vw", md: "4vw", sm:"4vw", xs:"6vw"}}}>PRO SHOPS</Typography>
                        </div>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Card> 
      </div>
  </Container>
  </Box>
  );
};
